/**
 *
 * @param {number} currentPage
 * @param {number} perPage
 * @returns {number}
 */
export default function getOffset(currentPage, perPage) {
  return (currentPage - 1) * perPage;
}
